const getters = {
  userInfo: state => state.user.userInfo,
  isLogin: state => state.user.isLogin,
  isChecked: state => state.user.isChecked,
  email: state => state.user.email,
  noReadMess: state => state.user.noReadMess, // 未读消息数据
  moduleChooseIndex: state => state.user.moduleChooseIndex, // 选择模块对应的索引
  fromPath: state => state.user.fromPath,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js